'use client'

import { useTranslations } from 'next-intl'
import Link from 'next/link'
import InfoCard from './info-card'
import SectionHeader from './section-header'

export default function SocialResponsibility() {
  const t = useTranslations('page_cam_ket_phat_trien')
  return (
    <div id='item-2-content'>
      <SectionHeader
        number='02'
        title={t.rich('social.title', {
          brMd: () => <br className='hidden md:block' />,
        })}
      />
      <div className='grid gap-5 md:grid-cols-2'>
        <InfoCard
          imageSrc='https://media.coolmate.me/image/October2024/mceclip12_17.png'
          imageAlt={t('social.card_1.alt')}
          title={
            <Link
              href='https://thuvientieuchuan.org/tieu-chuan-better-work-trach-nhiem-xa-hoi/'
              className='mb-3 flex items-center gap-2 font-criteria text-lg font-medium text-primary md:gap-3 md:text-xl'
            >
              {t('social.card_1.title')} <span>↗</span>
            </Link>
          }
          description={t('social.card_1.description')}
        />
        <InfoCard
          imageSrc='https://media.coolmate.me/image/November2024/mceclip8_44.png'
          imageAlt={t('social.card_2.alt')}
          title={t('social.card_2.title')}
          description={t('social.card_2.description')}
        />
      </div>
    </div>
  )
}
